/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SupplierCreateCommandV1 } from '../models/supplier-create-command-v-1';
import { SupplierIntegrationQueryV1 } from '../models/supplier-integration-query-v-1';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createSupplierV1Integration
   */
  static readonly CreateSupplierV1IntegrationPath = '/v1/integration/suppliers';

  /**
   * Create a new supplier without a request.
   *
   * Creates a new supplier directly without an associated supplier request. Returns 409 if a supplier with the same email already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSupplierV1Integration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierV1Integration$Response(params: {

    /**
     * Supplier data to create
     */
    body: SupplierCreateCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SupplierIntegrationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, IntegrationsV1Service.CreateSupplierV1IntegrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SupplierIntegrationQueryV1>;
      })
    );
  }

  /**
   * Create a new supplier without a request.
   *
   * Creates a new supplier directly without an associated supplier request. Returns 409 if a supplier with the same email already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSupplierV1Integration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierV1Integration(params: {

    /**
     * Supplier data to create
     */
    body: SupplierCreateCommandV1
  },
  context?: HttpContext

): Observable<SupplierIntegrationQueryV1> {

    return this.createSupplierV1Integration$Response(params,context).pipe(
      map((r: StrictHttpResponse<SupplierIntegrationQueryV1>) => r.body as SupplierIntegrationQueryV1)
    );
  }

}
